"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.isSkipped = exports.initialValues = exports.icon = exports.hasFeedback = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _optionTypes = _interopRequireDefault(require("./optionTypes"));
var _settings = require("../Player/settings.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = function () {
  var result = [];

  // Option types
  (0, _forEach2["default"])(_optionTypes["default"], function (optionType, name) {
    optionType.fields.forEach(function (field) {
      result.push("optionTypes.".concat(name, "[].").concat(field));
    });
  });
  return ['question', 'description', 'visualType', 'singleOrMultiple', 'imageSize', 'imagePadding', 'verticalOrHorizontal', 'verticalWidth', 'singleAnswerRequired', 'multiAnswerMin', 'multiAnswerMax', 'missingReportValue', 'dropdownZeroLabel', 'dropdownWidth', 'maxWidth', 'minButtonHeight', 'buttonTextAlign', 'showLabelsInMatrixHeader', 'requiredErrorMessage', 'minAnswersErrorMessage', 'maxAnswersErrorMessage', 'options[].id', 'options[].code', 'options[].type', 'options[].label', 'options[].isExpanded', 'isOptionsExpanded', 'isRadioDropdownExpanded', 'isSettingsExpanded', 'isRequiredExpanded', 'isValidationExpanded', 'hasCorrectAnswers', 'showCorrectnessFeedback', 'correctAnswers', 'showAnswerFeedbackExpanded', 'showAnswerFeedback', 'answerFeedbackForOptions', 'answerFeedbackPositive', 'answerFeedbackNegative'].concat(result);
}();
exports.fields = fields;
var ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings,
    isMatrixMode = _ref.isMatrixMode;
  var result = isMatrixMode ? [] : ['question', 'description'];
  result.push.apply(result, _toConsumableArray(settings.options.map(function (item, index) {
    return "options[".concat(index, "].label");
  })));
  return result;
};
exports.ttsFields = ttsFields;
var initialValues = {
  question: '<p><strong>What is your opinion about ...?</strong></p>',
  visualType: 'radio',
  labelPosition: 'top',
  singleOrMultiple: 'single',
  imageSize: 'medium',
  imagePadding: false,
  verticalOrHorizontal: 'vertical',
  verticalWidth: 'large',
  dropdownZeroLabel: '-- Choose an option --',
  dropdownWidth: 'auto',
  maxWidth: '300px',
  buttonTextAlign: 'center',
  requiredErrorMessage: 'An answer is required.',
  minAnswersErrorMessage: 'Choose :min or more items',
  maxAnswersErrorMessage: 'Choose :max or fewer items',
  options: [{
    id: 1,
    label: 'Choice',
    type: 'static'
  }, {
    id: 2,
    label: 'Choice',
    type: 'static'
  }, {
    id: 3,
    label: 'Choice',
    type: 'static'
  }],
  optionTypes: {
    "static": [{
      id: 1,
      userTextPlaceholder: '(Please specify)'
    }, {
      id: 2,
      userTextPlaceholder: '(Please specify)'
    }, {
      id: 3,
      userTextPlaceholder: '(Please specify)'
    }]
  },
  isOptionsExpanded: true,
  isRadioDropdownExpanded: true,
  hasCorrectAnswers: false,
  showCorrectnessFeedback: false
};
exports.initialValues = initialValues;
var icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-option-vertical"
});
exports.icon = icon;
var validate = function validate(values) {
  var errors = {};
  var options = values.options,
    singleOrMultiple = values.singleOrMultiple,
    multiAnswerMin = values.multiAnswerMin,
    multiAnswerMax = values.multiAnswerMax,
    visualType = values.visualType,
    renderInColumns = values.renderInColumns,
    verticalOrHorizontal = values.verticalOrHorizontal,
    hasCorrectAnswers = values.hasCorrectAnswers,
    correctAnswers = values.correctAnswers;
  (0, _forEach2["default"])(_optionTypes["default"], function (element, type) {
    var elementErrors = (0, _cccisdSurveyCommon.validateElement)(values.optionTypes[type] || [], element.validate);
    if (elementErrors.length === 0) {
      return;
    }
    errors = _objectSpread(_objectSpread({}, errors), {}, {
      optionTypes: _objectSpread(_objectSpread({}, errors.optionTypes), {}, _defineProperty({}, type, elementErrors))
    });
  });
  if (visualType === 'checkbox' || visualType === 'image' && singleOrMultiple === 'multiple' || visualType === 'button' && singleOrMultiple === 'multiple') {
    if (multiAnswerMin && !(0, _isInt["default"])(multiAnswerMin.toString(), {
      min: 1,
      max: options.length
    })) {
      errors.multiAnswerMin = "Value should be a number between 1 and ".concat(options.length);
    }
    if (multiAnswerMax && !(0, _isInt["default"])(multiAnswerMax.toString(), {
      min: 1,
      max: options.length
    })) {
      errors.multiAnswerMax = "Value should be a number between 1 and ".concat(options.length);
    }
    if (multiAnswerMin && multiAnswerMax && !errors.multiAnswerMin && !errors.multiAnswerMax) {
      if (+multiAnswerMin > +multiAnswerMax) {
        errors.multiAnswerMax = 'Max should be more than min';
      }
    }
  }
  if ((visualType === 'radio' || visualType === 'checkbox') && verticalOrHorizontal === 'horizontal') {
    if (renderInColumns && !(0, _isInt["default"])(renderInColumns.toString(), {
      min: 2,
      max: 10
    })) {
      errors.renderInColumns = 'Value should be a whole number 2 to 10';
    }
  }
  if (hasCorrectAnswers) {
    if (!correctAnswers || correctAnswers.length === 0) {
      errors.correctAnswers = 'Choose at least one correct answers';
    }
  }
  return errors;
};
exports.validate = validate;
var getMetricsPrefix = function getMetricsPrefix() {
  return 'mc';
};
exports.getMetricsPrefix = getMetricsPrefix;
var getDataDefinitions = function getDataDefinitions(id, settings) {
  var isMatrix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var metricsPrefix = getMetricsPrefix();
  var question = settings.question,
    visualType = settings.visualType,
    singleOrMultiple = settings.singleOrMultiple,
    options = settings.options,
    hasCorrectAnswers = settings.hasCorrectAnswers;
  var staticTypes = (0, _get2["default"])(settings, 'optionTypes.static', []);
  var hasLists = options.some(function (option) {
    return option.type === 'list';
  });
  if (hasLists) {
    var _ref2;
    var defintion = {
      type: 'text',
      variableType: 'answer',
      questionType: 'dynamicMultipleChoice',
      tags: {
        system: ['answer']
      },
      title: (0, _cccisdSurveyCommon.stripTags)(question),
      titleHtml: question
    };
    return _ref2 = {}, _defineProperty(_ref2, id + '_answer_id', _objectSpread(_objectSpread({}, defintion), {}, {
      reportHeader: "".concat(metricsPrefix, "_").concat(id, "_answer_id")
    })), _defineProperty(_ref2, id + '_answer_label', _objectSpread(_objectSpread({}, defintion), {}, {
      reportHeader: "".concat(metricsPrefix, "_").concat(id, "_answer_label")
    })), _ref2;
  }
  var isSingle = visualType === 'radio' || visualType === 'dropdown' || visualType === 'image' && singleOrMultiple === 'single' || visualType === 'button' && singleOrMultiple === 'single';
  if (isSingle) {
    var _data = _defineProperty({}, id + '_answer', {
      "enum": options.map(function (option) {
        return option.id;
      }),
      enumDisplayText: options.map(function (option) {
        return (0, _cccisdSurveyCommon.stripTags)(option.label);
      }),
      enumDisplayTextHtml: options.map(function (option) {
        return option.label;
      }),
      questionType: 'MC - select one',
      variableType: 'answer',
      reportHeader: "".concat(metricsPrefix, "_").concat(id, "_answer"),
      tags: {
        system: ['answer']
      }
    });
    if (!isMatrix) {
      _data[id + '_answer'].title = (0, _cccisdSurveyCommon.stripTags)(question);
      _data[id + '_answer'].titleHtml = question;
    } else {
      _data[id + '_answer'].subtitle2 = (0, _cccisdSurveyCommon.stripTags)(question);
      _data[id + '_answer'].subtitle2Html = question;
    }
    if (hasCorrectAnswers) {
      _data[id + '_correct_answer'] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(_data[id + '_answer'], ['title', 'titleHtml', 'subtitle2', 'subtitle2Html', 'tags', 'questionType'])), {}, {
        variableType: 'correct',
        reportHeader: "".concat(metricsPrefix, "_").concat(id, "_correct_answer"),
        "enum": [0, 1],
        enumDisplayText: ['incorrect', 'correct']
      });
    }
    options.filter(function (option) {
      return option.type === 'static';
    }).forEach(function (option) {
      var optionType = staticTypes.find(function (item) {
        return item.id === option.id;
      }) || {};
      if (optionType.allowUserText) {
        _data[id + '_user_text_' + option.id] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(_data[id + '_answer'], ['questionType', 'tags', 'title', 'titleHtml', 'subtitle1', 'subtitle1Html', 'subtitle2', 'subtitle2Html'])), {}, {
          type: 'text',
          variableType: 'qualitative',
          reportHeader: "".concat(metricsPrefix, "_").concat(id, "_user_text_").concat(option.id)
        }, !isMatrix ? {
          subtitle1: (0, _cccisdSurveyCommon.stripTags)(option.label),
          subtitle1Html: option.label
        } : {
          subtitle3: (0, _cccisdSurveyCommon.stripTags)(option.label),
          subtitle3Html: option.label
        });
      }
    });
    return _data;
  }
  var data = {};
  var prefix = id + '_answer_';
  (0, _forEach2["default"])(options, function (option) {
    data[prefix + option.id] = {
      "enum": [0, 1],
      enumDisplayText: ['unchecked', 'checked'],
      questionType: 'MC - select multiple',
      tags: {
        system: ['answer']
      },
      reportHeader: "".concat(metricsPrefix, "_").concat(prefix).concat(option.id),
      variableType: 'answer'
    };
    if (!isMatrix) {
      data[prefix + option.id].title = (0, _cccisdSurveyCommon.stripTags)(question);
      data[prefix + option.id].titleHtml = question;
      data[prefix + option.id].subtitle1 = (0, _cccisdSurveyCommon.stripTags)(option.label);
      data[prefix + option.id].subtitle1Html = option.label;
    } else {
      data[prefix + option.id].subtitle2 = (0, _cccisdSurveyCommon.stripTags)(question);
      data[prefix + option.id].subtitle2Html = question;
      data[prefix + option.id].subtitle3 = (0, _cccisdSurveyCommon.stripTags)(option.label);
      data[prefix + option.id].subtitle3Html = option.label;
    }
    if (option.type === 'static') {
      var optionType = staticTypes.find(function (item) {
        return item.id === option.id;
      }) || {};
      if (optionType.allowUserText) {
        data[id + '_user_text_' + option.id] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(data[prefix + option.id], ['questionType', 'tags', 'title', 'titleHtml', 'subtitle1', 'subtitle1Html', 'subtitle2', 'subtitle2Html', 'subtitle3', 'subtitle3Html'])), {}, {
          variableType: 'qualitative',
          type: 'text',
          reportHeader: "".concat(metricsPrefix, "_").concat(id, "_user_text_").concat(option.id)
        });
      }
      if (hasCorrectAnswers) {
        data[id + '_correct_answer_' + option.id] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(data[prefix + option.id], ['questionType', 'tags', 'title', 'titleHtml', 'subtitle1', 'subtitle1Html', 'subtitle2', 'subtitle2Html', 'subtitle3', 'subtitle3Html'])), {}, {
          variableType: 'correct',
          reportHeader: "".concat(metricsPrefix, "_").concat(id, "_correct_answer_").concat(option.id),
          "enum": [0, 1],
          enumDisplayText: ['incorrect', 'correct']
        });
      }
    }
  });
  return data;
};
exports.getDataDefinitions = getDataDefinitions;
var getMetrics = function getMetrics(id, settings, answer) {
  if (answer) {
    answer = (0, _settings.processValue)(answer);

    // if a user interacts with a radio and then de-selects it sets metrics to null
    if (!answer.selected.length) {
      answer = null;
    }
  }
  var visualType = settings.visualType,
    singleOrMultiple = settings.singleOrMultiple,
    options = settings.options,
    hasCorrectAnswers = settings.hasCorrectAnswers,
    correctAnswers = settings.correctAnswers;
  var staticTypes = (0, _get2["default"])(settings, 'optionTypes.static', []);
  var hasLists = options.some(function (option) {
    return option.type === 'list';
  });
  var staticIds = options.filter(function (option) {
    return option.type === 'static';
  }).map(function (option) {
    return option.id;
  });
  var userTextMetrics = staticTypes.filter(function (type) {
    return type.allowUserText && staticIds.includes(type.id);
  }).reduce(function (result, optionType) {
    result[id + '_user_text_' + optionType.id] = answer && typeof answer.userTexts[optionType.id] === 'string' ? answer.userTexts[optionType.id] : null;
    return result;
  }, {});
  var isSingle = visualType === 'radio' || visualType === 'dropdown' || visualType === 'image' && singleOrMultiple === 'single' || visualType === 'button' && singleOrMultiple === 'single';
  if (isSingle) {
    var _objectSpread5;
    var _correctMetrics = hasCorrectAnswers ? _defineProperty({}, id + '_correct_answer', null) : {};
    if (hasCorrectAnswers && answer && answer.selected && answer.selected.length > 0) {
      _correctMetrics[id + '_correct_answer'] = correctAnswers.includes(answer.selected[0]) ? 1 : 0;
    }
    if (!answer) {
      var _objectSpread3;
      return hasLists ? _objectSpread(_objectSpread((_objectSpread3 = {}, _defineProperty(_objectSpread3, id + '_answer_id', null), _defineProperty(_objectSpread3, id + '_answer_label', null), _objectSpread3), userTextMetrics), _correctMetrics) : _objectSpread(_objectSpread(_defineProperty({}, id + '_answer', null), userTextMetrics), _correctMetrics);
    }
    return hasLists ? _objectSpread((_objectSpread5 = {}, _defineProperty(_objectSpread5, id + '_answer_id', answer.selected[0].toString()), _defineProperty(_objectSpread5, id + '_answer_label', answer.selectedLabels[answer.selected[0]]), _objectSpread5), _correctMetrics) : _objectSpread(_objectSpread(_defineProperty({}, id + '_answer', answer.selected[0]), userTextMetrics), _correctMetrics);
  }
  var correctMetrics = {};
  if (hasCorrectAnswers) {
    var hasSomeAnswer = answer && answer.selected.length > 0;
    options.forEach(function (option) {
      if (!hasSomeAnswer) {
        correctMetrics[id + '_correct_answer_' + option.id] = null;
      } else {
        correctMetrics[id + '_correct_answer_' + option.id] = answer.selected.includes(option.id) === correctAnswers.includes(option.id) ? 1 : 0;
      }
    });
  }
  if (hasLists) {
    var _objectSpread8;
    if (!answer) {
      var _objectSpread7;
      return _objectSpread((_objectSpread7 = {}, _defineProperty(_objectSpread7, id + '_answer_id', null), _defineProperty(_objectSpread7, id + '_answer_label', null), _objectSpread7), correctMetrics);
    }
    return _objectSpread((_objectSpread8 = {}, _defineProperty(_objectSpread8, id + '_answer_id', JSON.stringify(answer.selected)), _defineProperty(_objectSpread8, id + '_answer_label', JSON.stringify(answer.selected.map(function (item) {
      return answer.selectedLabels[item];
    }))), _objectSpread8), correctMetrics);
  }
  var result = _objectSpread(_objectSpread({}, userTextMetrics), correctMetrics);
  var prefix = id + '_answer_';
  (0, _forEach2["default"])(options, function (option) {
    if (!answer) {
      result[prefix + option.id] = null;
    } else {
      result[prefix + option.id] = answer.selected.includes(option.id) ? 1 : 0;
    }
  });
  return result;
};
exports.getMetrics = getMetrics;
var getDataConnectors = function getDataConnectors(settings) {
  var hasLists = settings.options.some(function (option) {
    return option.type === 'list';
  });
  if (hasLists) {
    return {};
  }
  return {
    commaText: {
      type: 'string',
      title: 'Comma separated selected options'
    },
    listText: {
      type: 'string',
      title: 'Selected options as a list'
    },
    selectedArray: {
      deprecated: true,
      type: 'array',
      title: 'Selected codes',
      meta: {
        possibleValues: settings.options.filter(function (option) {
          return option.code;
        }).map(function (option) {
          return {
            value: option.code,
            label: (0, _cccisdSurveyCommon.shortenText)({
              text: (0, _cccisdSurveyCommon.stripTags)(option.label),
              length: 18
            })
          };
        })
      }
    },
    selectedCollection: {
      type: 'collection',
      title: 'Selected options'
    },
    selectedIds: {
      type: 'array',
      title: 'Selected options',
      meta: {
        possibleValues: settings.options.map(function (option) {
          return {
            value: option.id,
            label: (0, _cccisdSurveyCommon.shortenText)({
              text: (0, _cccisdSurveyCommon.stripTags)(option.label),
              length: 18
            })
          };
        })
      }
    }
  };
};
exports.getDataConnectors = getDataConnectors;
var getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  var hasLists = settings.options.some(function (option) {
    return option.type === 'list';
  });
  if (hasLists) {
    return {};
  }
  if (answer) {
    answer = (0, _settings.processValue)(answer);
  }
  return {
    commaText: function commaText() {
      if (!answer) {
        return answer;
      }
      var selected = settings.options.filter(function (option) {
        return answer.selected.includes(option.id);
      }).map(function (option) {
        var _answer;
        return ((_answer = answer) === null || _answer === void 0 ? void 0 : _answer.userTexts[option.id]) || (0, _cccisdWysiwyg.toHtml)(option.label);
      });
      if (selected.length <= 2) {
        return selected.join(language === 'es' ? ' y ' : ' and ');
      }
      return selected.slice(0, -1).join(', ') + (language === 'es' ? ' y ' : ', and ') + selected.slice(-1);
    },
    listText: function listText() {
      if (!answer) {
        return answer;
      }
      var list = settings.options.filter(function (option) {
        return answer.selected.includes(option.id);
      }).map(function (option) {
        var _answer2;
        var value = ((_answer2 = answer) === null || _answer2 === void 0 ? void 0 : _answer2.userTexts[option.id]) || (0, _cccisdWysiwyg.toHtml)(option.label);
        return "<li>".concat(value, "</li>");
      }).join('');
      return "<ul>".concat(list, "</ul>");
    },
    selectedArray: function selectedArray() {
      if (!answer) {
        return [];
      }
      return answer.selected.map(function (choiceId) {
        return (0, _find2["default"])(settings.options, {
          id: choiceId
        }).code;
      });
    },
    selectedCollection: function selectedCollection() {
      if (!answer) {
        return [];
      }
      return answer.selected.map(function (choiceId) {
        var option = (0, _find2["default"])(settings.options, {
          id: choiceId
        });
        return {
          id: choiceId,
          code: option.code,
          name: (0, _cccisdWysiwyg.toHtml)(option.label)
        };
      });
    },
    selectedIds: function selectedIds() {
      return answer ? answer.selected : [];
    }
  };
};
exports.getDataConnectorsValues = getDataConnectorsValues;
var hasFeedback = function hasFeedback(_ref4) {
  var settings = _ref4.settings,
    answer = _ref4.answer;
  if (answer && answer.selected && answer.selected.length > 0) {
    return true;
  }
  return false;
};
exports.hasFeedback = hasFeedback;
var isSkipped = function isSkipped(_ref5) {
  var settings = _ref5.settings,
    answer = _ref5.answer;
  if (!answer) {
    return true;
  }
  if (!answer.selected || answer.selected.length === 0) {
    return true;
  }
  return false;
};
exports.isSkipped = isSkipped;